import { render, staticRenderFns } from "./c-perfilconfig.vue?vue&type=template&id=4c3af312&scoped=true"
import script from "./c-perfilconfig.vue?vue&type=script&lang=js"
export * from "./c-perfilconfig.vue?vue&type=script&lang=js"
import style0 from "./c-perfilconfig.vue?vue&type=style&index=0&id=4c3af312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3af312",
  null
  
)

export default component.exports